import { useTranslate } from '@tolgee/react';
import { Button, ButtonProps, Popconfirm } from 'antd';
import { useVoucherOperate } from 'hooks/business/useVoucherOperate';

export interface VoucherOperationProps extends ButtonProps {
  status: Conversation.Voucher.Vo['voucherStatus'];
  conversation: Conversation.Conversation;
  voucher: Conversation.Voucher.Vo;
  onDelete: (voucher: Conversation.Voucher.Vo) => void;
  onUpdate: (voucher: Conversation.Voucher.Vo) => void;
}

function VoucherOperation(props: VoucherOperationProps) {
  const { status, conversation, voucher, onDelete, onUpdate } = props;
  const { t } = useTranslate();
  const {
    canVoid,
    canSuspendResume,
    voidVoucher,
    suspendResumeVoucher,
    voidLoading,
    suspendResumeLoading,
  } = useVoucherOperate(voucher, conversation);

  if (canVoid) {
    const disabled = voidLoading || status === 'SCHEDULED';
    return (
      <Popconfirm
        disabled={disabled}
        title={t('chatWorkspace.couponTab.invalidateConfirm.title')}
        onConfirm={() => {
          voidVoucher({ onSuccess: () => onDelete(voucher) });
        }}
      >
        <Button size="middle" disabled={disabled}>
          {t('coupon.action.invalidate')}
        </Button>
      </Popconfirm>
    );
  }

  if (canSuspendResume) {
    return (
      <Button
        size="middle"
        disabled={suspendResumeLoading}
        onClick={() => {
          suspendResumeVoucher({
            onSuccess: (res) => onUpdate(res),
          });
        }}
      >
        {voucher.suspendFlag ? t('coupon.action.activate') : t('coupon.action.suspend')}
      </Button>
    );
  }

  return null;
}

export default VoucherOperation;
